import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  skeletonContainer: {
    borderRadius: 0,
  },
  skeleton: {
    marginBottom: 8,
  },
  content: {
    padding: '0 !important',
  },
  row: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  rightCol: {
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  amount: {
    color: theme.palette.success.light,
  },
}));

export default useStyles;
